export default "images/question-img.png";